export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-shield-star-line',
      title: 'Licensed & Insured',
      description: 'Fully licensed electricians with comprehensive insurance coverage for your peace of mind.'
    },
    {
      icon: 'ri-time-line',
      title: 'Same Day Service',
      description: 'Fast response times with same-day service available for urgent electrical needs.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Transparent Pricing',
      description: 'Upfront quotes with no hidden fees. You know exactly what you\'re paying before we start.'
    },
    {
      icon: 'ri-award-line',
      title: 'Lifetime Guarantee',
      description: 'We stand behind our work with a lifetime guarantee on all electrical installations and repairs.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Emergency',
      description: 'Round-the-clock emergency service because electrical problems don\'t wait for business hours.'
    },
    {
      icon: 'ri-star-smile-line',
      title: '5.0 Google Rating',
      description: 'Consistently rated 5 stars by our customers for quality work and exceptional service.'
    }
  ];

  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#535669] mb-3 md:mb-4">
            Why Choose <span className="text-[#f67f19]">Urban Connect</span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Experience the difference that professional, reliable electrical service makes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 md:p-8 border-2 border-gray-100 hover:border-[#f67f19] transition-all hover:shadow-xl"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19]/10 rounded-full flex items-center justify-center mb-4 md:mb-6 group-hover:bg-[#f67f19] transition-colors">
                <i className={`${reason.icon} text-[#f67f19] group-hover:text-white text-2xl md:text-3xl transition-colors`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#535669] mb-2 md:mb-3">
                {reason.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}